import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const InputField = forwardRef(({
  name,
  label,
  sublabel,
  className,
  showError = false,
  error,
  showLabel = true,
  visuallyHidden = false,
  required = false,
  wrapperProps = {},
  labelProps = {},
  children,
  ...restProps
}, ref) => {
  const inputClasses = clsx(className, showError && 'error');
  const { className: wrapperClassName, ...restWrapperProps } = wrapperProps;
  const { className: labelClassName, ...restLabelProps } = labelProps;
  const wrapperClasses = clsx('form-item form-item--text', wrapperClassName);
  const labelClasses = clsx('form-item__label', visuallyHidden && 'visually-hidden', labelClassName);

  return (
    <div
      className={wrapperClasses}
      {...restWrapperProps}
    >
      {showLabel && (
        <>
          <label
            className={labelClasses}
            htmlFor={name}
            {...restLabelProps}
          >
            {label}
            {required && (
              <span className="required">*</span>
            )}
          </label>
          {sublabel && (
            <div className="form-item__sublabel">{sublabel}</div>
          )}
        </>
      )}
      <input
        ref={ref}
        type="text"
        name={name}
        id={name}
        className={inputClasses}
        {...restProps}
      />
      {children}
      {showError && (
        <div
          className="form-item__error"
        >
          {error}
        </div>
      )}
    </div>
  );
});

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  children: PropTypes.node,
  showError: PropTypes.bool,
  showLabel: PropTypes.bool,
  visuallyHidden: PropTypes.bool,
  required: PropTypes.bool,
};

export default InputField;
